import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Layers, PlusCircle, Cpu, BookOpen, Settings, Wrench } from 'lucide-react';

const NAV = [
  { to:'/',          label:'Dashboard',   Icon: LayoutDashboard },
  { to:'/jobs',      label:'Jobs',        Icon: Layers },
  { to:'/new-job',   label:'New Job',     Icon: PlusCircle },
  { to:'/machines',  label:'Machines',    Icon: Cpu },
  { to:'/rules',     label:'Eng. Rules',  Icon: BookOpen },
  { to:'/settings',  label:'Settings',    Icon: Settings },
];

export default function Layout({ children }: { children: React.ReactNode }) {
  const loc = useLocation();
  return (
    <div style={{ display:'flex', minHeight:'100vh', background:'var(--c-bg)' }}>
      {/* Sidebar */}
      <aside style={{
        width: 220, flexShrink: 0, background: 'var(--c-navy)',
        display: 'flex', flexDirection: 'column',
        position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 100,
      }}>
        {/* Logo */}
        <div style={{ padding:'20px 16px 18px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <div style={{
              width:34, height:34, background:'var(--c-amber)',
              borderRadius:8, display:'flex', alignItems:'center', justifyContent:'center',
            }}>
              <Wrench size={16} color="white" strokeWidth={2.5} />
            </div>
            <div>
              <div style={{ fontFamily:'Inter', fontWeight:700, fontSize:16, color:'#fff', letterSpacing:'-0.3px' }}>ForgeIQ</div>
              <div style={{ fontSize:9, color:'rgba(255,255,255,0.45)', letterSpacing:'0.12em', textTransform:'uppercase', marginTop:-1 }}>Process Planner</div>
            </div>
          </div>
        </div>

        {/* Nav */}
        <nav style={{ flex:1, padding:'12px 10px', overflowY:'auto' }}>
          <div style={{ fontSize:10, color:'rgba(255,255,255,0.3)', fontWeight:600, letterSpacing:'0.1em', textTransform:'uppercase', padding:'4px 8px 8px' }}>Navigation</div>
          {NAV.map(({ to, label, Icon }) => {
            const active = loc.pathname === to || (to !== '/' && loc.pathname.startsWith(to));
            return (
              <Link key={to} to={to} style={{ textDecoration:'none' }}>
                <div className="nav-link" style={{
                  color: active ? '#fff' : 'rgba(255,255,255,0.55)',
                  background: active ? 'rgba(255,255,255,0.12)' : 'transparent',
                  fontWeight: active ? 600 : 500,
                  marginBottom: 2,
                }}>
                  <Icon size={15} strokeWidth={active ? 2.5 : 2} />
                  {label}
                  {active && <div style={{ marginLeft:'auto', width:5, height:5, borderRadius:'50%', background:'var(--c-amber)' }} />}
                </div>
              </Link>
            );
          })}
        </nav>

        {/* Footer info */}
        <div style={{ padding:'14px 16px', borderTop:'1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ fontSize:10, color:'rgba(255,255,255,0.35)', lineHeight:1.6 }}>
            <div>Eng. Rules v2.1 · 6 machines</div>
            <div>8 templates · 11 materials</div>
            <div style={{ marginTop:4, color:'rgba(255,255,255,0.25)' }}>Sturdfix / SIL, Ludhiana</div>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <main style={{ flex:1, marginLeft:220, minHeight:'100vh' }}>
        <div style={{ padding:'28px 32px', maxWidth:1280 }}>
          {children}
        </div>
      </main>
    </div>
  );
}
